<template>
    <a class="game-91rushgames-link" :href="getHref">
        <slot></slot>
    </a>
</template>

<script>
    export default {
        props: {
            href: {
                type: String,
                required: true,
            },
        },
        computed: {
            getHref() {
                // 否则才追加当前页面的查询参数
                const sourceUrl = new URL(location.href);
                return this.href + sourceUrl.search;
            },
        },
    };
</script>

<style lang="less" scoped>
    .game-91rushgames-link {
        cursor: pointer;
    }
</style>
